import { Target, Phone, CreditCard, BookOpen } from 'lucide-react';

export const CATEGORY_CONFIG = {
  DO_NOW: { label: 'Do now', color: 'var(--pd-crimson)', desc: 'Requires attention now' },
  DELEGATE: { label: 'Delegate', color: 'var(--pd-warning)', desc: 'Hand off or batch' },
  DEFER: { label: 'Defer', color: 'var(--pd-muted)', desc: 'Revisit later' },
  IGNORE: { label: 'Park', color: 'var(--pd-subtle)', desc: 'Low value' },
  GRAVEYARD: { label: 'Graveyard', color: 'var(--pd-crimson)', desc: 'Deferred 5+ times' },
  COMPLETED: { label: 'Recently completed', color: 'var(--pd-success)', desc: 'Last 2 days' },
};

export const TYPE_ICON = { task: Target, call: Phone, payment: CreditCard, reading: BookOpen };

export const PRIORITY_COLOR = {
  URGENT: 'var(--pd-crimson)',
  HIGH: 'var(--pd-warning)',
  MEDIUM: 'var(--pd-focus)',
  LOW: 'var(--pd-subtle)',
};

export function getDeferralStyle(deferralCount) {
  if (deferralCount >= 5) return { borderLeft: '3px solid var(--pd-crimson)', background: 'rgba(180,35,58,0.03)' };
  if (deferralCount >= 3) return { borderLeft: '3px solid var(--pd-warning)', background: 'rgba(180,83,9,0.04)' };
  if (deferralCount >= 2) return { borderLeft: '3px solid rgba(180,83,9,0.5)', background: 'rgba(180,83,9,0.02)' };
  return {};
}
